import React from 'react';
import './Loader.css';

const Loader = ({ size = 'medium', color = '#333', fullPage = false }) => {
  const loaderClass = `loader ${size} ${fullPage ? 'full-page' : ''}`;
  
  return (
    <div className={loaderClass}>
      <div 
        className="loader-spinner" 
        style={{ borderTopColor: color }}
      ></div>
    </div>
  );
};

export default Loader;
